export default "__VITE_ASSET__BU4E4LOn__"